export default __webpack_public_path__ + "static/media/cover.91912325.jpg";